import { createContext } from "react";
import type { ItemType } from "@/pages/withdrawals/choose-method/payment-method-selector-card/types";

export type TSearchContext = {
  setSearchValue: (value: string) => void;
  searchValue: string;
  setListMode: (mode: ItemType) => void;
  listMode: ItemType;
};

export const SearchContext = createContext<TSearchContext>({
  listMode: "saved",
  searchValue: "",
  setListMode(): void {},
  setSearchValue(): void {},
});
